import isEmpty from '../utilities/isEmpty';
import ActionTypes from '../actions/actionTypes';
import { UserState } from 'types/UserState';

const initialState: UserState = {
  isLoading: false,
  isError: false,
  users: [],
  totalSize: 0,
  user: {},
  grandParentAccountNumber: undefined,
  currentGrandfatherClientNumber: undefined,
  currentGrandfatherAccountName: undefined,
  isSuccessful: false,

  loginUserLoading: false,
  loginUserLoaded: false,
  loginUserError: false,

  downloadUsersLoading: false,
  downloadUsersLoaded: false,
  downloadUsersError: false,

  downloadAllUsersLoading: false,
  downloadAllUsersLoaded: false,
  downloadAllUsersError: false,

  createUserLoading: false,
  createUserLoaded: false,
  createUserError: false,

  deleteUserLoading: false,
  deleteUserLoaded: false,
  deleteUserError: false,

  adminDeleteUserLoading: false,
  adminDeleteUserLoaded: false,
  adminDeleteUserError: false,

  updateUserLoading: false,
  updateUserLoaded: false,
  updateUserError: false,

  adminUpdateUserLoading: false,
  adminUpdateUserLoaded: false,
  adminUpdateUserError: false,

  detailedUserLoading: false,
  detailedUserLoaded: false,
  detailedUserError: false,
  detailedUser: {},

  adminDetailedUserLoading: false,
  adminDetailedUserLoaded: false,
  adminDetailedUserError: false,
  adminDetailedUser: {},

  searchAllUsers: [],
  searchAllUsersResultSize: 0,
  searchAllUsersLoading: false,
  searchAllUsersLoaded: false,
  searchAllUsersError: false,

  filteredUsers: [],
  filteredUsersResultSize: 0,
  filteredLoading: false,
  filteredLoaded: false,
  filteredError: false,

  impersonateLoading: false,
  impersonateLoaded: false,
  impersonateError: false,

  loggedInUser: {
    accounts: [],
    emailId: '',
    familyName: '',
    givenName: '',
    roles: [],
    status: '',
    userId: ''
  },
  loggedInUserLoading: false,
  loggedInUserLoaded: false,
  loggedInUserError: false,

  isAmpolAdmin: false,
  isUserUnauthorised: false,

  assignedPortalAccountsList: [],
  assignedPortalAccountsListResultSize: 0,
  assignedPortalAccountsListLoading: false,
  assignedPortalAccountsListLoaded: false,
  assignedPortalAccountsListError: false,

  removeAccountAccessForUserLoading: false,
  removeAccountAccessForUserLoaded: false,
  removeAccountAccessForUserError: false,

  canReadWriteAccounts: false,
  canReadWriteCards: false,
  canReadWriteCash: false,
  canReadWriteReports: false,
  canReadWriteUsers: false,
  canReadWriteMaintenance: false,
  canImpersonateUser: false,

  assignAccountsToUserLoading: false,
  assignAccountsToUserLoaded: false,
  assignAccountsToUserError: false,

  assignAccountsRequest: {},

  userEmailLookupLoading: false,
  userEmailLookupLoaded: false,
  userEmailLookupError: false,
  userEmailLookup: null,

  userEmailExists: false,

  updateUserProfileSelfLoading: false,
  updateUserProfileSelfLoaded: false,
  updateUserProfileSelfError: false,

  logoutLoading: false,
  logoutLoaded: false,
  logoutError: false,

  searchUserExists: false,
  searchUserExistsLoading: false,
  searchUserExistsLoaded: false,
  searchUserExistsError: false,

  adminSearchUserExists: false,
  adminSearchUserExistsLoading: false,
  adminSearchUserExistsLoaded: false,
  adminSearchUserExistsError: false,
};

export function usersReducer(state = initialState, { type, payload }): UserState {
  let users, totalSize;
  switch (type) {
    case ActionTypes.USERS.FETCH.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        users: [],
      };
    case ActionTypes.USERS.FETCH.SUCCESS:
      users = payload.users;
      totalSize = payload.totalSize;
      return {
        ...state,
        isLoading: false,
        users,
        totalSize,
      };
    case ActionTypes.USERS.FETCH.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        users: [],
        totalSize: 0,
      };
    case ActionTypes.USERS.FETCH.RESET:
      return {
        ...state,
        isLoading: false,
        isError: false,
        totalSize: 0,
        users: [],
      };
    case ActionTypes.USERS.DOWNLOAD.REQUEST:
      return {
        ...state,
        downloadUsersLoading: true,
        downloadUsersLoaded: false,
        downloadUsersError: false,
      };
    case ActionTypes.USERS.DOWNLOAD.SUCCESS:
      return {
        ...state,
        downloadUsersLoading: false,
        downloadUsersLoaded: true
      };
    case ActionTypes.USERS.DOWNLOAD.FAILURE:
      return {
        ...state,
        downloadUsersLoading: false,
        downloadUsersError: true,
      };
    case ActionTypes.USERS.DOWNLOAD_ALL_USERS.REQUEST:
      return {
        ...state,
        downloadAllUsersLoading: true,
        downloadAllUsersLoaded: false,
        downloadAllUsersError: false,
      };
    case ActionTypes.USERS.DOWNLOAD_ALL_USERS.SUCCESS:
      return {
        ...state,
        downloadAllUsersLoading: false,
        downloadAllUsersLoaded: true
      };
    case ActionTypes.USERS.DOWNLOAD_ALL_USERS.FAILURE:
      return {
        ...state,
        downloadAllUsersLoading: false,
        downloadAllUsersError: true,
      };
    case ActionTypes.USERS.DELETE.REQUEST:
      return {
        ...state,
        deleteUserLoading: true,
        deleteUserLoaded: false,
        deleteUserError: false
      };
    case ActionTypes.USERS.DELETE.SUCCESS:
      return {
        ...state,
        deleteUserLoading: false,
        deleteUserLoaded: true
      };
    case ActionTypes.USERS.DELETE.FAILURE:
      return {
        ...state,
        deleteUserLoading: false,
        deleteUserError: true
      };
    case ActionTypes.USERS.DELETE.RESET:
      return {
        ...state,
        deleteUserLoading: false,
        deleteUserLoaded: false,
        deleteUserError: false
      };
    case ActionTypes.USERS.ADMIN_DELETE_USER.REQUEST:
      return {
        ...state,
        adminDeleteUserLoading: true,
        adminDeleteUserLoaded: false,
        adminDeleteUserError: false
      };
    case ActionTypes.USERS.ADMIN_DELETE_USER.SUCCESS:
      return {
        ...state,
        adminDeleteUserLoading: false,
        adminDeleteUserLoaded: true
      };
    case ActionTypes.USERS.ADMIN_DELETE_USER.FAILURE:
      return {
        ...state,
        adminDeleteUserLoading: false,
        adminDeleteUserError: true
      };
    case ActionTypes.USERS.ADMIN_DELETE_USER.RESET:
      return {
        ...state,
        adminDeleteUserLoading: false,
        adminDeleteUserLoaded: false,
        adminDeleteUserError: false
      };
    case ActionTypes.USERS.SEARCH_ALL_USERS.REQUEST:
      return {
        ...state,
        searchAllUsersError: false,
        searchAllUsersLoaded: false,
        searchAllUsersLoading: true,
      };
    case ActionTypes.USERS.SEARCH_ALL_USERS.SUCCESS:
      return {
        ...state,
        searchAllUsersLoaded: true,
        searchAllUsersLoading: false,
        searchAllUsers: payload.users,
        searchAllUsersResultSize: payload.totalSize,
      };
    case ActionTypes.USERS.SEARCH_ALL_USERS.FAILURE:
      return {
        ...state,
        searchAllUsersError: true,
        searchAllUsersLoading: false,
        searchAllUsers: [],
        searchAllUsersResultSize: 0,
      };
    case ActionTypes.USERS.SEARCH_ALL_USERS.RESET:
      return {
        ...state,
        searchAllUsersError: false,
        searchAllUsersLoaded: false,
        searchAllUsersLoading: false,
        searchAllUsers: [],
        searchAllUsersResultSize: 0,
      };
    case ActionTypes.USERS.SEARCH_ALL_IMPERSONATE_USERS.REQUEST:
      return {
        ...state,
        filteredError: false,
        filteredLoaded: false,
        filteredLoading: true,
      };
    case ActionTypes.USERS.SEARCH_ALL_IMPERSONATE_USERS.SUCCESS:
      return {
        ...state,
        filteredLoaded: true,
        filteredLoading: false,
        filteredUsers: payload.users,
        filteredUsersResultSize: payload.totalSize,
      };
    case ActionTypes.USERS.SEARCH_ALL_IMPERSONATE_USERS.FAILURE:
      return {
        ...state,
        filteredError: true,
        filteredLoading: false,
      };
    case ActionTypes.USERS.SEARCH_ALL_IMPERSONATE_USERS.RESET:
      return {
        ...state,
        filteredError: false,
        filteredLoaded: false,
        filteredLoading: false,
        filteredUsers: [],
      };
    case ActionTypes.USERS.IMPERSONATE_USER.REQUEST:
      return {
        ...state,
        impersonateError: false,
        impersonateLoaded: false,
        impersonateLoading: true,
      };
    case ActionTypes.USERS.IMPERSONATE_USER.SUCCESS:
      return {
        ...state,
        impersonateLoaded: true,
        impersonateLoading: false,
      };
    case ActionTypes.USERS.IMPERSONATE_USER.FAILURE:
      return {
        ...state,
        impersonateError: true,
        impersonateLoading: false,
      };
    case ActionTypes.USERS.LOGIN_USER.REQUEST:
      return {
        ...state,
        loginUserLoading: true,
        loginUserLoaded: false,
        loginUserError: false,
      };
    case ActionTypes.USERS.LOGIN_USER.SUCCESS:
      return {
        ...state,
        loginUserLoading: false,
        loginUserLoaded: true,
      };
    case ActionTypes.USERS.LOGIN_USER.FAILURE:
      return {
        ...state,
        loginUserLoading: false,
        loginUserError: true,
      };
    case ActionTypes.USERS.ME.REQUEST:
      return {
        ...state,
        loggedInUserLoading: true,
        loggedInUserLoaded: false,
        loggedInUserError: false,
      };
    case ActionTypes.USERS.ME.SUCCESS:
      return {
        ...state,
        loggedInUserLoading: false,
        loggedInUserLoaded: true,
        loggedInUser: payload.user,
      };
    case ActionTypes.USERS.ME.FAILURE:
      return {
        ...state,
        loggedInUserLoading: false,
        loggedInUserError: true,
        httpStatusCode: payload?.response?.status
      };
    case ActionTypes.USERS.SET_ASSIGNED_GRANDFATHER_DETAILS:
      return {
        ...state,
        assignedGrandfatherClientNumber: payload?.grandParentAccountNumber,
        assignedGrandfatherAccountName: payload?.name,
        assignedAccountNumber: payload?.accountNumber,
      };
    case ActionTypes.USERS.SET_CAN_READ_WRITE:
      return {
        ...state,
        canReadWriteAccounts: payload?.accounts || false,
        canReadWriteCards: payload?.cards || false,
        canReadWriteCash: payload?.cash || false,
        canReadWriteReports: payload?.reports || false,
        canReadWriteUsers: payload?.users || false,
        canReadWriteMaintenance: payload?.maintenance || false,
        canImpersonateUser: payload?.impersonate || false,
      };
    case ActionTypes.USERS.SET_USER_AS_ADMIN:
      return {
        ...state,
        isAmpolAdmin: true
      };
    case ActionTypes.USERS.SET_USER_AS_UNAUTHORISED:
      return {
        ...state,
        isUserUnauthorised: true,
      };
    case ActionTypes.USERS.SET_PORTAL_TYPE:
      return {
        ...state,
        portalType: payload,
      };
    case ActionTypes.USERS.ADMIN_GET_ASSIGNED_ACCOUNTS.REQUEST:
      return {
        ...state,
        assignedPortalAccountsListLoading: true,
        assignedPortalAccountsListLoaded: false,
        assignedPortalAccountsListError: false,
        assignedPortalAccountsList: [],
        assignedPortalAccountsListResultSize: 0,
      };
    case ActionTypes.USERS.ADMIN_GET_ASSIGNED_ACCOUNTS.SUCCESS:
      return {
        ...state,
        assignedPortalAccountsListLoading: false,
        assignedPortalAccountsListLoaded: true,
        assignedPortalAccountsList: payload.assignedPortalAccountsList,
        assignedPortalAccountsListResultSize: payload.assignedPortalAccountsListResultSize
      };
    case ActionTypes.USERS.ADMIN_GET_ASSIGNED_ACCOUNTS.FAILURE:
      return {
        ...state,
        assignedPortalAccountsListLoading: false,
        assignedPortalAccountsListError: true,
      };
    case ActionTypes.USERS.ADMIN_REMOVE_ACCOUNT_ACCESS.REQUEST:
      return {
        ...state,
        removeAccountAccessForUserLoading: true,
        removeAccountAccessForUserLoaded: false,
        removeAccountAccessForUserError: false,
      };
    case ActionTypes.USERS.ADMIN_REMOVE_ACCOUNT_ACCESS.SUCCESS:
      return {
        ...state,
        adminDeleteUserLoading: false,
        adminDeleteUserLoaded: payload?.isLastAccount ? payload.isLastAccount : false,
        adminDeleteUserError: false,
        removeAccountAccessForUserLoading: false,
        removeAccountAccessForUserLoaded: true,
      };
    case ActionTypes.USERS.ADMIN_REMOVE_ACCOUNT_ACCESS.FAILURE:
      return {
        ...state,
        removeAccountAccessForUserLoading: false,
        removeAccountAccessForUserError: true,
      };
    case ActionTypes.USERS.ADMIN_REMOVE_ACCOUNT_ACCESS.RESET:
      return {
        ...state,
        removeAccountAccessForUserLoading: false,
        removeAccountAccessForUserLoaded: false,
        removeAccountAccessForUserError: false,
      };
    case ActionTypes.USERS.ASSIGN_ACCOUNTS.REQUEST:
      return {
        ...state,
        assignAccountsToUserLoading: true,
        assignAccountsToUserLoaded: false,
        assignAccountsToUserError: false,
      };
    case ActionTypes.USERS.ASSIGN_ACCOUNTS.SUCCESS:
      return {
        ...state,
        assignAccountsToUserLoading: false,
        assignAccountsToUserLoaded: true
      };
    case ActionTypes.USERS.ASSIGN_ACCOUNTS.FAILURE:
      return {
        ...state,
        assignAccountsToUserLoading: false,
        assignAccountsToUserError: true
      };
    case ActionTypes.USERS.ASSIGN_ACCOUNTS.RESET:
      return {
        ...state,
        assignAccountsToUserLoading: false,
        assignAccountsToUserLoaded: false,
        assignAccountsToUserError: false,
      };
    case ActionTypes.USERS.UPDATE_ASSIGN_ACCOUNTS_REQUEST:
      return {
        ...state,
        assignAccountsRequest: payload.assignAccountsRequest
      };
    case ActionTypes.USERS.DETAILED_FETCH.REQUEST:
      return {
        ...state,
        detailedUserLoading: true,
        detailedUserLoaded: false,
        detailedUserError: false,
      };
    case ActionTypes.USERS.DETAILED_FETCH.SUCCESS:
      return {
        ...state,
        detailedUserLoading: false,
        detailedUserLoaded: true,
        detailedUser: payload.user,
      };
    case ActionTypes.USERS.DETAILED_FETCH.FAILURE:
      return {
        ...state,
        detailedUserLoading: false,
        detailedUserError: true,
      };
    case ActionTypes.USERS.DETAILED_FETCH.RESET:
      return {
        ...state,
        detailedUserLoading: false,
        detailedUserLoaded: false,
        detailedUserError: false,
        detailedUser: {},
      };
    case ActionTypes.USERS.ADMIN_DETAILED_FETCH.REQUEST:
      return {
        ...state,
        adminDetailedUserLoading: true,
        adminDetailedUserLoaded: false,
        adminDetailedUserError: false,
      };
    case ActionTypes.USERS.ADMIN_DETAILED_FETCH.SUCCESS:
      return {
        ...state,
        adminDetailedUserLoading: false,
        adminDetailedUserLoaded: true,
        adminDetailedUser: payload.user,
      };
    case ActionTypes.USERS.ADMIN_DETAILED_FETCH.FAILURE:
      return {
        ...state,
        adminDetailedUserLoading: false,
        adminDetailedUserError: true,
      };
    case ActionTypes.USERS.ADMIN_DETAILED_FETCH.RESET:
      return {
        ...state,
        adminDetailedUserLoading: false,
        adminDetailedUserLoaded: false,
        adminDetailedUserError: false,
        adminDetailedUser: {},
      };
    case ActionTypes.USERS.UPDATE.REQUEST:
      return {
        ...state,
        updateUserLoading: true,
        updateUserLoaded: false,
        updateUserError: false
      };
    case ActionTypes.USERS.UPDATE.SUCCESS:
      return {
        ...state,
        updateUserLoading: false,
        updateUserLoaded: true,
        detailedUser: {
          ...state.detailedUser, 
          ...payload.user,
        },
      };
    case ActionTypes.USERS.UPDATE.FAILURE:
      return {
        ...state,
        updateUserLoading: false,
        updateUserError: true
      };
    case ActionTypes.USERS.UPDATE.RESET:
      return {
        ...state,
        updateUserLoading: false,
        updateUserLoaded: false,
        updateUserError: false
      };
    case ActionTypes.USERS.ADMIN_UPDATE_USER.REQUEST:
      return {
        ...state,
        adminUpdateUserLoading: true,
        adminUpdateUserLoaded: false,
        adminUpdateUserError: false
      };
    case ActionTypes.USERS.ADMIN_UPDATE_USER.SUCCESS:
      return {
        ...state,
        adminUpdateUserLoading: false,
        adminUpdateUserLoaded: true,
        adminDetailedUser: {
          ...state.adminDetailedUser, 
          ...payload.user,
        },
      };
    case ActionTypes.USERS.ADMIN_UPDATE_USER.FAILURE:
      return {
        ...state,
        adminUpdateUserLoading: false,
        adminUpdateUserError: true
      };
    case ActionTypes.USERS.ADMIN_UPDATE_USER.RESET:
      return {
        ...state,
        adminUpdateUserLoading: false,
        adminUpdateUserLoaded: false,
        adminUpdateUserError: false
      };
    case ActionTypes.USERS.CREATE.REQUEST:
      return {
        ...state,
        createUserLoading: true,
        createUserLoaded: false,
        createUserError: false
      };
    case ActionTypes.USERS.CREATE.SUCCESS:
      return {
        ...state,
        createUserLoading: false,
        createUserLoaded: true,
        user: payload.user
      };
    case ActionTypes.USERS.CREATE.FAILURE:
      return {
        ...state,
        createUserLoading: false,
        createUserError: true,
        httpStatusCode: payload.response.status
      };
    case ActionTypes.USERS.CREATE.RESET:
      return {
        ...state,
        createUserLoading: false,
        createUserLoaded: false,
        createUserError: false
      };
    case ActionTypes.USERS.EMAIL_LOOKUP.REQUEST:
      return {
        ...state,
        userEmailLookupLoading: true,
        userEmailLookupLoaded: false,
        userEmailLookupError: false,
      };
    case ActionTypes.USERS.EMAIL_LOOKUP.SUCCESS:
      return {
        ...state,
        userEmailLookupLoading: false,
        userEmailLookupLoaded: true,
        userEmailExists: !isEmpty(payload.emailId) && !isEmpty(payload.user),
        userEmailLookup: {
          emailId: payload.emailId,
          user: payload.user
        },
      };
    case ActionTypes.USERS.EMAIL_LOOKUP.FAILURE:
      return {
        ...state,
        userEmailLookupLoading: false,
        userEmailLookupError: true,
        httpStatusCode: payload.response.status
      };
    case ActionTypes.USERS.EMAIL_LOOKUP.RESET:
      return {
        ...state,
        userEmailLookupLoading: false,
        userEmailLookupLoaded: false,
        userEmailLookupError: false,
        userEmailExists: false,
        userEmailLookup: {
          emailId: '',
          user: ''
        },
      };
    case ActionTypes.USERS.UPDATE_USER_SELF.REQUEST:
      return {
        ...state,
        updateUserProfileSelfLoading: true,
        updateUserProfileSelfLoaded: false,
        updateUserProfileSelfError: false,
      };
    case ActionTypes.USERS.UPDATE_USER_SELF.SUCCESS:
      return {
        ...state,
        updateUserProfileSelfLoading: false,
        updateUserProfileSelfLoaded: true,
        user: payload.user,
        loggedInUser: {
          ...state.loggedInUser,
          ...payload.user,
        },
      };
    case ActionTypes.USERS.UPDATE_USER_SELF.FAILURE:
      return {
        ...state,
        updateUserProfileSelfLoading: false,
        updateUserProfileSelfError: true,
      };
    case ActionTypes.USERS.UPDATE_USER_SELF.RESET:
      return {
        ...state,
        updateUserProfileSelfLoading: false,
        updateUserProfileSelfLoaded: false,
        updateUserProfileSelfError: false,
      };
    case ActionTypes.USERS.LOGOUT.REQUEST:
      return {
        ...state,
        logoutLoading: true,
        logoutLoaded: false,
        logoutError: false,
      };
    case ActionTypes.USERS.LOGOUT.SUCCESS:
      return {
        ...state,
        logoutLoading: false,
        logoutLoaded: true,
      };
    case ActionTypes.USERS.LOGOUT.FAILURE:
      return {
        ...state,
        logoutLoading: false,
        logoutError: true,
      };
    case ActionTypes.USERS.SEARCH_USER_EXISTS.REQUEST:
      return {
        ...state,
        searchUserExistsLoading: true,
        searchUserExistsLoaded: false,
        searchUserExistsError: false,
        searchUserExists: false,
      };
    case ActionTypes.USERS.SEARCH_USER_EXISTS.SUCCESS:
      return {
        ...state,
        searchUserExistsLoading: false,
        searchUserExistsLoaded: true,
        searchUserExistsError: false,
        searchUserExists: payload.totalSize === 1,
      };
    case ActionTypes.USERS.SEARCH_USER_EXISTS.FAILURE:
      return {
        ...state,
        searchUserExistsLoading: false,
        searchUserExistsLoaded: false,
        searchUserExistsError: true,
        searchUserExists: false,
      };
    case ActionTypes.USERS.ADMIN_SEARCH_USER_EXISTS.REQUEST:
      return {
        ...state,
        adminSearchUserExistsLoading: true,
        adminSearchUserExistsLoaded: false,
        adminSearchUserExistsError: false,
        adminSearchUserExists: false,
      };
    case ActionTypes.USERS.ADMIN_SEARCH_USER_EXISTS.SUCCESS:
      return {
        ...state,
        adminSearchUserExistsLoading: false,
        adminSearchUserExistsLoaded: true,
        adminSearchUserExistsError: false,
        adminSearchUserExists: payload.totalSize === 1,
      };
    case ActionTypes.USERS.ADMIN_SEARCH_USER_EXISTS.FAILURE:
      return {
        ...state,
        adminSearchUserExistsLoading: false,
        adminSearchUserExistsLoaded: false,
        adminSearchUserExistsError: true,
        adminSearchUserExists: false,
      };
    default:
      return state;
  }
}
